import type { Product } from '../api/products';

/** `material · printing`, uppercased for the poster styling, or null when the operator left both blank. */
export function productSpecLine(product: Product | undefined): string | null {
  const parts = [product?.material, product?.printing].map((s) => (s ?? '').trim()).filter(Boolean);
  return parts.length > 0 ? parts.join(' · ').toUpperCase() : null;
}

/**
 * Material, print and description as the operator entered them. Every field is
 * optional per product, and orders for a soft-deleted product resolve to no
 * product at all, so each line is dropped rather than filled with a placeholder.
 */
export function ProductSpec({
  product,
  fontSize = 10.5,
}: {
  product: Product | undefined;
  fontSize?: number;
}) {
  const specLine = productSpecLine(product);
  const description = (product?.description ?? '').trim();
  if (!specLine && !description) return null;

  return (
    <span style={{ display: 'block', marginTop: 3 }}>
      {specLine && (
        <span
          className="mono"
          style={{
            display: 'block',
            fontSize,
            color: 'rgba(var(--shop-muted-rgb),.55)',
            letterSpacing: '.08em',
          }}
        >
          {specLine}
        </span>
      )}
      {description && (
        <span
          style={{
            display: 'block',
            fontSize: fontSize + 0.5,
            color: 'rgba(var(--shop-muted-rgb),.7)',
            lineHeight: 1.45,
          }}
        >
          {description}
        </span>
      )}
    </span>
  );
}
